<app-page-title [title]="'Set your password'"></app-page-title>
<div class="row">
    <div class="col-md-12">
        <p>Enter your new password below:</p>
    </div>
</div>
<div class="form-container">
    <div class="row">
        <div class="col-md-5">
            <form
                name="reset-password-form"
                [formGroup]="userForm"
                (ngSubmit)="onSubmit()"
            >
                <div class="form-group">
                    <label>Password</label>
                    <input
                        type="password"
                        autocomplete="off"
                        class="form-control"
                        name="password"
                        placeholder="Password"
                        maxlength="128"
                        formControlName="newPassword"
                    />
                    <app-password-strength-meter [newPassword]="userForm.controls.newPassword.value"></app-password-strength-meter>
                    <small
                        class="error"
                        *ngIf="f.newPassword.dirty && f.newPassword.errors?.required"
                    >Please enter a new password.</small>
                    <small
                        class="error"
                        *ngIf="f.newPassword.dirty && f.newPassword.errors?.pattern"
                    >Must be at least 8 characters long and a mixture of numbers and letters.</small>
                </div>
                <div class="form-group">
                    <label>Confirm Password</label>
                    <input
                        type="password"
                        autocomplete="off"
                        class="form-control"
                        name="passwordConfirm"
                        placeholder="Confirm Password"
                        maxlength="128"
                        formControlName="newPasswordConfirm"
                    />
                    <small
                        class="error"
                        *ngIf="f.newPasswordConfirm.dirty && f.newPasswordConfirm.errors?.required"
                    >Please confirm your password.</small>
                    <small
                        class="error"
                        *ngIf="f.newPasswordConfirm.dirty && f.newPassword.value && f.newPasswordConfirm.value && f.newPasswordConfirm.value != f.newPassword.value"
                    >Passwords do not match.</small>
                </div>
                <div class="form-group">
                    <button
                        name="confirmationYesBtn"
                        type="submit"
                        class="btn btn-primary"
                    >Confirm</button>
                </div>
            </form>
        </div>
    </div>
</div>
